import { ListResponseType } from "@shared/types";
import CoreAPI from "../CoreAPI";

const apiClient = new CoreAPI();

interface ICommonApi {
  fetchCommonAddress: (code: string) => Promise<ListResponseType<AddressItem>>;
}

export interface AddressItem {
  code: string;
  name: string;
  contact: string | null;
  phone: string | null;
  address: string;
  zipcode: string;
}

const commonApi: ICommonApi = {
  fetchCommonAddress: async (code: string | undefined) => {
    const response = await apiClient.getData("/manage/logistic/common-address/", { code });
    return response.data.result;
  },
};

export default commonApi;
